import SuiBox, {
    SuiBoxProps,
} from '@upheal/design-system/components/legacy/Sui/SuiBox';

import { ConsentConfirmation } from '../Consent/ConsentConfirmation';
import { useFeatureFlagEnabled } from 'posthog-js/react';

export type Props = React.PropsWithChildren<
    SuiBoxProps & {
        background?: 'default' | 'gradient';
        backgroundImage?: string;
    }
>;

function PageLayout({
    background = 'default',
    backgroundImage,
    children,
    ...rest
}: Props) {
    const isClientConsentDisabled = useFeatureFlagEnabled(
        'disable-feature-client-consent',
    );

    return (
        <SuiBox
            height="100%"
            minHeight="100dvh"
            {...rest}
            sx={{
                overflowX: 'hidden',
                ...(background === 'gradient'
                    ? {
                          backgroundImage: (theme) =>
                              `url("${
                                  backgroundImage ??
                                  theme.palette.gradientBackground.image
                              }")`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundColor: (theme) =>
                              theme.palette.gradientBackground.fallbackColor, // use this before the image loads
                      }
                    : {
                          backgroundColor: background,
                      }),
                ...rest.sx,
            }}
        >
            {!isClientConsentDisabled && <ConsentConfirmation />}

            {children}
        </SuiBox>
    );
}

export default PageLayout;
